import { useQuery } from "react-query";
import { TotaisRelatorioReceitas } from "../typings";
import { AxiosError } from "axios";
import http from "infra/http";
import { RelatorioReceitasQueryParams } from "./../typings/index";

function useRelatorioReceitasTotais(query: RelatorioReceitasQueryParams, enabled: boolean = true) {
  return useQuery<TotaisRelatorioReceitas, AxiosError>(
    [`/v1/relatorios/financeiro/receitas/totais`, query],
    async () => {
      const { data } = await http.get<TotaisRelatorioReceitas>(
        "/v1/relatorios/financeiro/receitas/totais",
        {
          params: query,
        }
      );

      return data;
    }, {
      enabled
    }
  );
}

export default useRelatorioReceitasTotais;
